import AppConstants from '../constants/appConstants';
import { getLocalUser } from '../utils/auth';
import { authGet } from '../utils/fecth-wrappers';
import {
  buildPurchasesQueryDateRange,
  isAuthGetErrorResponse,
  logPromoMyPurchasesDiagnostic,
  parseDealerApiResponse,
  parseMyPurchasesList,
  parseTimeBenefitsBannerResponse,
  resolveDealerRegisteredAt,
} from '../utils/promoNovosLojistas';

/**
 * Dealer logado — firstLoginAt vem de ic-api-dealers/v1/dealers/:id
 */
export async function fetchDealerForPromoBanner() {
  const user = getLocalUser();
  const dealerId = user?.getId?.();

  if (!dealerId) {
    return null;
  }

  const response = await authGet(AppConstants.API.dealerById(dealerId));
  const dealer = parseDealerApiResponse(response);

  if (!dealer) {
    throw new Error(
      `Dealer ${dealerId} sem dados (status: ${response?.responseStatus ?? 'ok'})`
    );
  }

  return dealer;
}

/**
 * Config do banner (time-benefits-club).
 */
export async function fetchPromoBannerTimeConfig() {
  const response = await authGet(AppConstants.API.promoBannerTimeConfig);

  if (response?.responseStatus) {
    throw new Error('Não foi possível carregar a config do banner promo');
  }

  return parseTimeBenefitsBannerResponse(response);
}

/**
 * GET au_queries/v1/my-purchases
 * Ex.: .../my-purchases?dateStart=18/05/2026&dateEnd=27/05/2026&dealerId={userId}
 * dateStart/dateEnd = createdAt até createdAt + firstLoginTimeValidationInHours
 */
export async function fetchPurchasesInValidationWindow({ createdAt, validationHours }) {
  const user = getLocalUser();
  const dealerId = user?.getId?.();
  const dateRange = buildPurchasesQueryDateRange({ createdAt, validationHours });

  if (!dealerId || !dateRange?.dateStart || !dateRange?.dateEnd) {
    return [];
  }

  // Mesmo formato de Minhas compras — barras em dd/mm/yyyy sem encode (%2F).
  const query = `dateStart=${dateRange.dateStart}&dateEnd=${dateRange.dateEnd}&dealerId=${dealerId}`;
  const requestUrl = `${AppConstants.API.historyAuctions}?${query}`;
  const rawResponse = await authGet(requestUrl);

  if (isAuthGetErrorResponse(rawResponse)) {
    throw new Error(
      `my-purchases falhou (status: ${rawResponse?.responseStatus ?? 'unknown'})`
    );
  }

  const apiPayload =
    rawResponse?.data?.body != null || Array.isArray(rawResponse?.data?.body)
      ? rawResponse.data
      : rawResponse;

  const purchases = parseMyPurchasesList(apiPayload);

  try {
    logPromoMyPurchasesDiagnostic({
      requestUrl,
      createdAt,
      validationHours,
      response: rawResponse,
      purchases,
    });
  } catch (logError) {
    console.warn('[PromoBanner] Falha ao logar diagnóstico my-purchases:', logError);
  }

  return purchases;
}

/**
 * Compras na janela do cadastro (createdAt) — valida disputa ganha no promoEligible.
 */
export async function fetchPurchasesForPromoEligible({ dealer, timeConfig }) {
  const createdAt = resolveDealerRegisteredAt(dealer);
  const validationHours = timeConfig?.firstLoginValidationHours;

  if (!createdAt || !validationHours) {
    return [];
  }

  return fetchPurchasesInValidationWindow({ createdAt, validationHours });
}
